module.exports = __webpack_public_path__ + "img/HY3703-193.f5a7b4d8.jpg";